import { render, staticRenderFns } from "./collectionAgreementLogAdd.vue?vue&type=template&id=7b007b95&scoped=true"
import script from "./collectionAgreementLogAdd.vue?vue&type=script&lang=js"
export * from "./collectionAgreementLogAdd.vue?vue&type=script&lang=js"
import style0 from "./collectionAgreementLogAdd.vue?vue&type=style&index=0&id=7b007b95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b007b95",
  null
  
)

export default component.exports